import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { getAuthToken, getRole } from "../tokenService";

const getBasePath = () =>
  typeof window !== "undefined" && window.location.pathname.startsWith("/portal") ? "/portal" : "";

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, updateActivity, setUser } = useAuth();
  const location = useLocation();

  // Check localStorage and sync with AuthContext if needed
  React.useEffect(() => {
    if (!user) {
      const token = getAuthToken();
      const role = getRole();
      if (token && role) {
        setUser({ role });
      }
    }
  }, [user, setUser]);

  // Update activity on route access
  React.useEffect(() => {
    if (user) {
      updateActivity();
    }
  }, [user, updateActivity]);

  const token = getAuthToken();
  const role = getRole();
  const isAuthenticated = user || (token && role);
  const userRole = user?.role || role;

  // Redirect via window.location to avoid "The operation is insecure" (history.replace blocked in some HTTPS contexts)
  const shouldRedirectToUnauthorized =
    (!isAuthenticated && location.pathname !== "/" && location.pathname !== "/unauthorized") ||
    (allowedRoles && (!userRole || !allowedRoles.includes(userRole)));

  React.useEffect(() => {
    if (shouldRedirectToUnauthorized) {
      const base = getBasePath();
      window.location.href = base + "/unauthorized";
    }
  }, [shouldRedirectToUnauthorized]);

  if (shouldRedirectToUnauthorized) {
    return null;
  }

  return children;
};